'use client';

import { useCallback } from 'react';
import { Keypair } from '@solana/web3.js';
import { Wallet } from '@velocity-exchange/sdk';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import useVelocityAccountsStore from 'src/stores/useVelocityAccountsStore';
import { notify } from 'src/utils/notifications';
import useVelocityClient from '../useVelocityClient';

const useWalletDisconnect = () => {
	const velocityClient = useVelocityClient();

	const set = useVelocityStore((s) => s.set);
	const resetAccountsState = useVelocityAccountsStore(
		(s) => s.resetAccountsState
	);

	const handleWalletDisconnect = useCallback(() => {
		notify({
			id: 'wallet_disconnection',
			type: 'success',
			message: 'Disconnected from wallet',
			updatePrevious: true,
		});

		set((s) => {
			s.wallet.currentPublicKeyString = null;
			s.wallet.isAppKit = false;
			s.wallet.isPrivyNativeAuth = false;
		});

		velocityClient?.updateWallet(new Wallet(new Keypair()));

		resetAccountsState();
	}, [set, resetAccountsState, velocityClient]);

	return {
		handleWalletDisconnect,
	};
};

export default useWalletDisconnect;
